import axios from 'axios';
import { requestHandler, successHandler, errorHandler } from './interceptor/axiosInterceptor';
import constants from "../constants/constants";

const safeApiUrl = constants.API_URL || "";
const axiosInstance = axios.create({
    baseURL: safeApiUrl.endsWith('api/') ? safeApiUrl : safeApiUrl.endsWith('api') ? safeApiUrl + '/' : safeApiUrl.endsWith('/') ? safeApiUrl + 'api/' : safeApiUrl + '/api/'
})

axiosInstance.interceptors.request.use(
    request => requestHandler(request)
)

axiosInstance.interceptors.response.use(
    response => successHandler(response),
    err => errorHandler(err)
)

export default axiosInstance;